import { AppButton } from '@clickguard/design-system'
import { ChangeEvent } from 'react'
import { GInput } from 'components/basic-blocks'

interface DomainInputProps {
	domain: string
	domainError: string | null
	isLoading: boolean
	onDomainChange: (e: ChangeEvent<HTMLInputElement>) => void
	onGenerate: () => void
}

export const DomainInput = ({
	domain,
	domainError,
	isLoading,
	onDomainChange,
	onGenerate
}: DomainInputProps) => {
	return (
		<div className="flex flex-col pt-2">
			<div className="flex gap-6 items-start flex-col md:flex-row md:items-end">
				<div className="flex-1">
					<GInput
						name="domain"
						label="Domain"
						placeholder="clientwebsite.com"
						value={domain}
						onChange={onDomainChange}
						error={domainError || undefined}
						errorPosition="flex"
						labelClassName="text-[14px] leading-[18px] font-medium text-t-google-ad"
						inputClassName="w-full text-[16px] leading-[22px] text-t-coupon"
					/>
				</div>
				<div className="py-[2px]">
					<AppButton
						variant="marketing"
						size="lg"
						label="Generate instructions"
						isLoading={isLoading}
						loader="dots"
						disabled={isLoading || !domain.trim()}
						onClick={onGenerate}
					/>
				</div>
			</div>
		</div>
	)
}
